/* @flow */
import * as React from 'react';
import BugNubForm from 'internal/components/BugNubForm';
import Glyph from 'components/Glyph';
import Heading from 'components/Heading';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import apiRequest from 'lib/apiRequest';

import './styles/BugNubFloatingBox.scss';

type AsanaUserInfo = { value: string, label: string };

function fetchAsanaUsers() {
  return apiRequest('/bugs/asana_users', 'GET').then(res =>
    res.asana_users.map(u => ({ value: u.id.toString(), label: u.name }))
  );
}

type Props = {
  onToggle?: Function,
  remove: Function,
};

type State = {
  asanaUsers: AsanaUserInfo[],
};

export default class BugNubFloatingBox extends React.Component<Props, State> {
  static WIDTH = 400;
  static HEIGHT = 352;
  static POSITION = 'bottom-right';
  static SUPPRESS_TEXT_SELECTION = false;

  state = {
    asanaUsers: [],
  };

  componentDidMount() {
    fetchAsanaUsers()
      .then(asanaUsers => this.setState({ asanaUsers }))
      .catch(e => console.log(e));
  }

  removeFloatingBox = () => {
    if (this.props.onToggle) {
      this.props.onToggle();
    }
    this.props.remove();
  };

  render() {
    return (
      <div className="BugNubFloatingBox">
        <Row size="small">
          <MediaObject figure="right">
            <Heading>Log a bug</Heading>
            <Glyph name="close" size="medium" onClick={this.removeFloatingBox} />
          </MediaObject>
        </Row>
        <BugNubForm onSubmit={this.removeFloatingBox} asanaUsers={this.state.asanaUsers} />
      </div>
    );
  }
}
